import { render, staticRenderFns } from "./OrderConfirmedPage.vue?vue&type=template&id=1d3b3221"
import script from "./OrderConfirmedPage.vue?vue&type=script&lang=js"
export * from "./OrderConfirmedPage.vue?vue&type=script&lang=js"
import style0 from "./OrderConfirmedPage.vue?vue&type=style&index=0&id=1d3b3221&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports